import { render, staticRenderFns } from "./defaultIngredientWidget.vue?vue&type=template&id=7a1442ce&scoped=true&"
import script from "./defaultIngredientWidget.vue?vue&type=script&lang=js&"
export * from "./defaultIngredientWidget.vue?vue&type=script&lang=js&"
import style0 from "./defaultIngredientWidget.vue?vue&type=style&index=0&id=7a1442ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1442ce",
  null
  
)

export default component.exports